import { PartyService } from './../../../services/api/party/party.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource, MatDialogRef, MatDialog } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, Subscription, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { Router, ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { ProductViewTable  } from 'src/app/models/interface/product/productViewTable';
import { ProductService } from 'src/app/services/api/product/product.service';
import { CFS_STATES, INFO_TYPES, PRODUCT_STATES, RFS_ERRORS, RFS_STATES } from 'src/app/utils/Constants';
import { Role } from 'src/app/utils/Role';
import { KeycloakService } from 'keycloak-angular';
import { AppService } from 'src/app/app.service';
import { Title } from '@angular/platform-browser';
import { NewProductSuccessComponent } from '../new-product-success/new-product-success.component';
import { PreviousRouteService } from 'src/app/services/api/previous-route/previous-route.service';
import { isNumber } from 'util';
import { HttpParams } from '@angular/common/http';
import { HttpUrlEncodingCodec } from 'src/app/utils/http-url-encoding-codec';
import moment from 'moment';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { Party } from 'src/app/models/party-manager/party';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-search-products',
  templateUrl: './search-products.component.html',
  styleUrls: ['./search-products.component.scss']
})
export class SearchProductsComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  isps: any[];
  infoType = 'PRODUCT';
  rfsError: any;
  nameSpecId: any;
  productState: any;

  userRoles: string[];
  allRoles: any;
  canAdd: boolean;

  dataSource: MatTableDataSource<ProductViewTable>;

  tooltip = {
    refresh: '',
    clear: '',
    edit: ''
  };

  pendingActions = {
    queryProducts: false,
    dialogChangeStatus: false
  };

  combos = {
    infoType: [],
    specId: [],
    productState: [],
    cfsState: [],
    rfsState: [],
    origin: [],
    rfsError: [],
    hasOperationalState: []
  };

  filterValues = {
    infoType: null,
    specId: null,
    productState: null,
    cfsState: null,
    rfsState: null,
    origin: null,
    rfsError: null,
    hasOperationalState: null,
    optionsISP: null
  };

  displayedColumns: string[];

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  private writingTimeout = 500;

  title: string;
  subtitle: string;

  appData: any;
  paramsObject: any;

  csvLoading = false;

  params: HttpParams;

  form = new FormGroup({
    searchKey: new FormControl(''),
    serviceId: new FormControl(''),
    specId: new FormControl(null),
    productState: new FormControl(null),
    externalId: new FormControl(''),
    cfsState: new FormControl(null),
    rfsState: new FormControl(null),

    requestDatePrevious: new FormControl(null),
    requestDatePost: new FormControl(null),
    terminationDatePrevious: new FormControl(null),
    terminationDatePost: new FormControl(null),
    origin: new FormControl(null),
    hasOperationalState: new FormControl(null),
  });

  constructor(
    private translate: TranslateService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private dialog: MatDialog,
    private productService: ProductService,
    private partyService: PartyService,
    private keycloakService: KeycloakService,
    private appService: AppService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private previousRouteService: PreviousRouteService,
    private notificationsService: NotificationsService,
    private utilsService: UtilsService
  ) {


  }


  ngOnInit() {

    if (this.titleService.getTitle().includes(" - ")) {
      this.titleService.setTitle(this.titleService.getTitle().split(" - ")[1]);
    }

    this.appData = this.appService.settings;
    this.userRoles = this.keycloakService.getUserRoles();
    this.allRoles = Role;

    if (this.userRoles.includes(Role.Admin)) {
      this.canAdd = true;
    }
    else {
      this.canAdd = false;
    }

    this.title = 'Productos';
    this.subtitle = 'Permite consultar el listado de productos almacenados en el Inventario de Servicios.';

    this.isps = [];

    this.displayedColumns = [
      'specId',
      'searchKey',
      'profile',
      'externalId',
      'serviceId',
      'productState',
      'createdAt',
      'terminationDate',
      'origin'
    ];

    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Productos', url: 'provision/products/search' }
          ]
      }
    );

    this.dataSource = null;
    this.initTooltips();
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;
    this.sort.active = 'createdAt';
    this.sort.direction = 'desc';

    this.combos.productState = [{ name: 'Cualquiera', value: null }].concat(PRODUCT_STATES);
    this.filterValues.productState = this.combos.productState[0].value;

    this.combos.infoType = INFO_TYPES;
    this.filterValues.infoType = this.combos.infoType[0].value;

    this.combos.cfsState = [{ name: 'Cualquiera', value: null }].concat(CFS_STATES);
    this.filterValues.cfsState = this.combos.cfsState[0].value;

    this.combos.rfsState = [{ name: 'Cualquiera', value: null }].concat(RFS_STATES);
    this.filterValues.rfsState = this.combos.rfsState[0].value;

    this.combos.rfsError = [{ name: 'Cualquiera', value: null }].concat(RFS_ERRORS);
    this.filterValues.rfsError = this.combos.rfsError[0].value;

    this.combos.hasOperationalState = [
      { name: 'Cualquiera', value: null },
      { name: 'Sólo productos con errores', value: 'true' },
      { name: 'Sólo productos sin errores', value: 'false' }
    ];
    this.filterValues.hasOperationalState = this.combos.hasOperationalState[0].value;


    this.combos.origin.push({ name: 'Cualquiera', code: null });


    this.partyService.getCustomers().subscribe((data) => {
      for (const party of data) {
        this.combos.origin.push(party);
        this.isps.push(party);
      }
      this.combos.origin.sort(function (a, b) {
        if (a.name === "Cualquiera") return -1;
        if (b.name === "Cualquiera") return 1;
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : 0
      });
      this.filterValues.origin = this.combos.origin[0].code;
      this.initFormFromParams();
    });

    if (this.previousRouteService.getPreviousUrl() && this.previousRouteService.getPreviousUrl().includes('products/new')) {
      this.activatedRoute.queryParamMap
        .subscribe(queryParams => {
          if (queryParams.has('idadministrativo')) {
            this.dialog.open(NewProductSuccessComponent,
              {
                data: {
                  idadministrativo: queryParams.get('idadministrativo')
                },
                hasBackdrop: false,
              });
          }
        }
        );
    }
  }

  private updateParamsObject() {
    this.params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .append('page', this.paginator.pageIndex.toString())
      .append('size', this.paginator.pageSize.toString())
      .append('infoType', this.infoType);

    let sort = this.sort.active ? this.sort.active + ',' + this.sort.direction : null;

    if (sort) {
      this.params = this.params.append('sort', sort);
    }

    if (this.nameSpecId) {
      this.params = this.params.append('specId', this.nameSpecId);
    }

    if (this.infoType === 'RFS' && this.rfsError) {
      this.params = this.params.append('rfsError', this.rfsError);
    }

    if (this.productState != null) {
      this.params = this.params.append('productState', this.productState);
    }

    Object.keys(this.form.value).forEach(key => {
      if (this.form.value[key] && (key.includes('request') || key.includes('termination'))) {
        this.params = this.params.append(key, moment(this.form.value[key]).format(`yyyy-MM-DDTHH:mm:ss.SSSSZ`));
      } else if (this.form.value[key] && this.form.value[key] !== '') {
        this.params = this.params.append(key, this.form.value[key]);
      }
    });

    this.paramsObject = {};

    for (const param of this.params.keys()) {
      this.paramsObject[param] = this.params.get(param);
    }

  }

  inputChanged() {
    this.modelChanged.next();
  }

  searchKeyInputChanged() {
    if (this.form.controls['searchKey'].value.length > 2 || this.form.controls['searchKey'].value.length === 0) {
      this.inputChanged();
    }
  }

  serviceIdInputChanged() {
    if (this.form.controls['serviceId'].value.length > 2 || this.form.controls['serviceId'].value.length === 0) {
      this.inputChanged();
    }
  }

  externalIdInputChanged() {
    if (this.form.controls['externalId'].value.length > 2 || this.form.controls['externalId'].value.length === 0) {
      this.inputChanged();
    }
  }

  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.refresh = this.translate.instant('TOOLTIPS.refreshResults');
      this.tooltip.clear = this.translate.instant('TOOLTIPS.clearForm');
    });
  }

  private subscribeToFormChanges() {
    this.subscription = this.modelChanged
      .pipe(
        debounceTime(this.writingTimeout),
      ).subscribe((value) => {
        this.submitForm(false);
      });
  }

  public changeType() {

    this.filterValues.specId = this.combos.specId[0].value;
    this.nameSpecId = this.combos.specId[0].value;

    this.combos.productState = [{ name: 'Cualquiera', value: null }].concat(PRODUCT_STATES);
    this.filterValues.productState = this.combos.productState[0].value;
    this.productState = this.combos.specId[0].value;

    this.combos.cfsState = [{ name: 'Cualquiera', value: null }].concat(CFS_STATES);
    this.filterValues.cfsState = this.combos.cfsState[0].value;

    this.combos.rfsState = [{ name: 'Cualquiera', value: null }].concat(RFS_STATES);
    this.filterValues.rfsState = this.combos.rfsState[0].value;

    this.combos.rfsError = [{ name: 'Cualquiera', value: null }].concat(RFS_ERRORS);
    this.filterValues.rfsError = this.combos.rfsError[0].value;

    this.checkChange(false);

    this.modelChanged.next();
  }

  private checkChange(firstAccess: boolean) {
    if (this.infoType === 'CFS') {
      this.productService.getCFSSpecs().subscribe(result => {
        this.combos.specId = [{ name: 'Cualquiera', value: null }].concat(result);
        if (firstAccess) {
          this.checkRemainingParamsAndSearch()
        }
        else {
          this.filterValues.specId = this.combos.specId[0].value;
        }
      });
    }

    if (this.infoType === 'RFS') {
      this.productService.getRFSSpecs().subscribe(result => {
        this.combos.specId = [{ name: 'Cualquiera', value: null }].concat(result);
        if (firstAccess) {
          this.checkRemainingParamsAndSearch();
        }
        else {
          this.filterValues.specId = this.combos.specId[0].value;
        }
      });
    }

    if (this.infoType === 'PRODUCT') {
      this.productService.getProductSpecs().subscribe(result => {
        this.combos.specId = [{ name: 'Cualquiera', value: null }].concat(result);
        if (firstAccess) {
          this.checkRemainingParamsAndSearch();
        }
        else {
          this.filterValues.specId = this.combos.specId[0].value;
        }
      });
    }
  }

  private checkRemainingParamsAndSearch() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.filterValues.specId = params['specId'] && this.combos.specId.some(specId => specId.value === params['specId']) ? params['specId'] : this.combos.specId[0].value;
      this.nameSpecId = params['specId'] && this.combos.specId.some(specId => specId.value === params['specId']) ? params['specId'] : this.combos.specId[0].value;
      this.paginator.pageIndex = params['page'] && isNumber(params['page']) ? params['page'] : this.paginator.pageIndex;
      this.paginator.pageSize = params['size'] && isNumber(params['size']) ? params['size'] : this.paginator.pageSize;
      this.sort.active = params['sort'] && params['sort'].split(',') ? params['sort'].split(',')[0] : this.sort.active;
      this.sort.direction = params['sort'] && params['sort'].split(',') ? params['sort'].split(',')[1] : this.sort.direction;
      switch (this.infoType) {
        case 'PRODUCT':
          this.filterValues.productState = params['productState'] && this.combos.productState.some(productState => productState.value === params['productState']) ? params['productState'] : this.combos.productState[0].value;
          this.productState = params['productState'] && this.combos.productState.some(productState => productState.value === params['productState']) ? params['productState'] : this.combos.productState[0].value;
          break;
        case 'CFS':
          this.filterValues.cfsState = params['productState'] && this.combos.cfsState.some(cfsState => cfsState.value === params['productState']) ? params['productState'] : this.combos.cfsState[0].value;
          this.productState = params['productState'] && this.combos.cfsState.some(cfsState => cfsState.value === params['productState']) ? params['productState'] : this.combos.cfsState[0].value;
          break;
        case 'RFS':
          this.filterValues.rfsState = params['productState'] && this.combos.rfsState.some(rfsState => rfsState.value === params['productState']) ? params['productState'] : this.combos.rfsState[0].value;
          this.productState = params['productState'] && this.combos.rfsState.some(rfsState => rfsState.value === params['productState']) ? params['productState'] : this.combos.rfsState[0].value;
          this.filterValues.rfsError = params['rfsError'] && this.combos.rfsError.some(rfsError => rfsError.value === params['rfsError']) ? params['rfsError'] : this.combos.rfsError[0].value;
          this.rfsError = params['rfsError'] && this.combos.rfsError.some(rfsError => rfsError.value === params['rfsError']) ? params['rfsError'] : this.combos.rfsError[0].value;
          break;
      }
      this.form.controls['searchKey'].setValue(params['searchKey'] ? params['searchKey'] : this.form.controls['searchKey'].value);
      this.form.controls['externalId'].setValue(params['externalId'] ? params['externalId'] : this.form.controls['externalId'].value);
      this.form.controls['serviceId'].setValue(params['serviceId'] ? params['serviceId'] : this.form.controls['serviceId'].value);
      this.form.controls['origin'].setValue(params['origin'] ? params['origin'] : this.form.controls['origin'].value);
      this.form.controls['serviceId'].setValue(params['serviceId'] ? params['serviceId'] : this.form.controls['serviceId'].value);
      this.form.controls['hasOperationalState'].setValue(params['hasOperationalState'] ? params['hasOperationalState'] : this.form.controls['hasOperationalState'].value);
      this.form.controls['requestDatePrevious'].setValue(params['requestDatePrevious'] ? new Date(params['requestDatePrevious']) : this.form.controls['requestDatePrevious'].value);
      this.form.controls['requestDatePost'].setValue(params['requestDatePost'] ? new Date(params['requestDatePost']) : this.form.controls['requestDatePost'].value);
      this.form.controls['terminationDatePrevious'].setValue(params['terminationDatePrevious'] ? new Date(params['terminationDatePrevious']) : this.form.controls['terminationDatePrevious'].value);
      this.form.controls['terminationDatePost'].setValue(params['terminationDatePost'] ? new Date(params['terminationDatePost']) : this.form.controls['terminationDatePost'].value);
    });
    this.updateParamsObject();
    this.dataSource = new MatTableDataSource();
    this.submitForm(false);
    this.subscribeToFormChanges();
  }

  public submitForm(paginate: boolean) {
    const DATA: ProductViewTable [] = [];

    this.updateParamsObject();
    this.updateUrl();

    this.productService.getProducts(
      this.params
    ).subscribe((data) => {
      for (const product of data.content) {
        DATA.push(product);
      }
      this.dataSource.data = DATA;
      this.paginator.length = data.totalElements;
      if (!paginate) {
        this.paginator.firstPage();
      }
    },
      (error) => {

      })
  }

  private initFormFromParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.filterValues.infoType = params['infoType'] && this.combos.infoType.some(infoType => infoType.value === params['infoType']) ? params['infoType'] : this.combos.infoType[0].value;
      this.infoType = params['infoType'] && this.combos.infoType.some(infoType => infoType.value === params['infoType']) ? params['infoType'] : this.combos.infoType[0].value;
    });
    this.checkChange(true);
  }

  public clearForm() {
    this.form.reset();
    this.filterValues.infoType = this.combos.infoType[0].value;
    this.infoType = this.combos.infoType[0].value;
    this.checkChange(false);
    this.filterValues.specId = this.combos.specId[0].value;
    this.nameSpecId = this.combos.specId[0].value;
    this.filterValues.productState = this.combos.productState[0].value;
    this.productState = this.combos.productState[0].value;
    this.filterValues.cfsState = this.combos.cfsState[0].value;
    this.filterValues.rfsState = this.combos.rfsState[0].value;
    this.filterValues.rfsError = this.combos.rfsError[0].value;
    this.rfsError = this.combos.rfsError[0].value;
    this.updateParamsObject();
    this.updateUrl();
  }

  private updateUrl() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.paramsObject,
      skipLocationChange: false
    });
  }

  public clearAndQueryForm(firstAccess: boolean) {
    this.clearForm();
    this.submitForm(false);
  }

  goToNewProduct() {
    this.router.navigate(['provision/products/new']);
  }

  public goToProduct(product: ProductViewTable ): void {
    window.open(`${this.appData.baseUrl}${this.appData.basePath}/provision/products/detail?id=${product.id}`, '_blank');
  }

  public getProductsCsv() {
    this.csvLoading = true;
    this.notificationsService.showNotificationWithDuration('El fichero está siendo generado....', NotificationLevel.INFO, 30000);
    const fileDownloadPromise = this.productService.getProductsCsv(this.params);
    this.utilsService.downloadFileV2(fileDownloadPromise, () => this.finish());
  }

  private finish(): void {
		this.csvLoading = false;
	}

}
